import { useNavigate, useRouteError } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

export default function NotFoundPage() {
  const error = useRouteError() as { status?: number; statusText?: string } | undefined;
  const navigate = useNavigate();
  const is404 = !error || error.status === 404;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 12, gap: 2 }}>
      <Typography variant="h2">{is404 ? '404' : (error?.status ?? 'Error')}</Typography>
      <Typography variant="h6" color="text.secondary">
        {is404 ? 'Page not found' : (error?.statusText ?? 'Something went wrong')}
      </Typography>
      <Button variant="contained" onClick={() => navigate('/')}>
        Go home
      </Button>
    </Box>
  );
}
